import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';
import { toast } from 'react-toastify';
import { GetAllPublicPath } from "../utils/getAllPublicPath";
import authService from '../utils/authService';
import { JWT_KEY_FROM_URL } from "../constants/jwtConstant";
import { ApiRequestError } from '../utils/apiRequestError';
import { DEFAULT_API_ERROR_MESSAGE, getApiErrorMessage } from '../utils/getApiErrorMessage';
import { GetEnvVar } from '../utils/getEnvironmentCurrent';

const instance = axios.create({
    baseURL: GetEnvVar(),
});

instance.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
        const token = authService.getToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error: AxiosError) => Promise.reject(error)
);

const responseBody = (response: any) => {
    console.log('Printing response in responsebody')
    console.log(response)
    if (response?.Title === undefined)
        return response.data
}

const Error = (err: AxiosError) => {
    console.log("Printing error Error in api", err?.response, err?.code, err?.message)
    // @ts-ignore
    console.log(err?.response, err?.response?.status)
    if (err?.response !== null && err?.response !== undefined) {
        if ((err?.response.status === 401 || err?.response.status === 403) && !GetAllPublicPath().includes(window.location.pathname)) {
            const hasJwtInUrl = window.location.search.includes(`${JWT_KEY_FROM_URL}=`);
            if (!hasJwtInUrl) {
                authService.saveReturnTo();
                window.location.pathname = "/";
            }
        }
        else if (err?.response?.status == 404 && !window.location.pathname.includes("page-not-found")) {
            window.location.pathname = "/page-not-found";
        } else if (err?.response.status !== 401) {
            const message = getApiErrorMessage(err, DEFAULT_API_ERROR_MESSAGE);
            toast.error(message);
            throw new ApiRequestError(message, err, true);
        }
    }
    throw err;
}

const requests = {
    get: async (url: string) => {
        try {
            const response = await instance.get(url, {
                headers: {
                    "Content-Type": "application/json"
                },
            });
            // @ts-ignore
            if (response?.flagStatus === false && response?.error !== "" && response?.error !== null && response?.error !== undefined) {
                alert("Something went wrong.!");
            }
            else {
                return responseBody(response);
            }
        } catch (err: any) {
            Error(err);
        }
    },

    post: async (url: string, body: any) => {
        try {
            const response = await instance.post(url, body, {
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return responseBody(response);
        } catch (err: any) {
            Error(err);
        }
    },

    // Silent post — skips the global toast handler; caller is responsible for error handling
    postSilent: async (url: string, body: any) => {
        const response = await instance.post(url, body, {
            headers: {
                "Content-Type": "application/json"
            }
        });
        return responseBody(response);
    },

    getBlob: async (url: string) => {
        return instance.get(url, { responseType: "blob" });
    },

    postBlob: async (url: string, body: any) => {
        return instance.post(url, body, {
            responseType: "blob",
            headers: {
                "Content-Type": "application/json",
            },
        });
    },

    put: async (url: string, body: any = {}) => {
        try {
            const response = await instance.put(url, body, {
                headers: {
                    "Content-Type": "application/json"
                },
            });

            return responseBody(response);

        } catch (err: any) {
            console.error("PUT request error:", err); // Use console.error instead of Error()
            throw err; // Rethrow error for proper handling
        }
    },

    postForm: async (url: string, formData: FormData) => {
        try {
            const response = await instance.post(url, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            return responseBody(response);
        } catch (err: any) {
            Error(err);
        }
    },

    putForm: async (url: string, formData: FormData) => {
        try {
            const response = await instance.put(url, formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                },
            });
            return responseBody(response);
        } catch (err: any) {
            Error(err);
        }
    },
};


export { requests };